import memoize from 'lodash-es/memoize';
import {
    USER_STROLLERS_ADD_REVIEW,
    USER_STROLLERS_DELETE,
    USER_STROLLERS_MY_REVIEW,
} from 'mk/autogenerated/translations/UserStrollerItem.b23e86e8244d6820b699dd17e6bf2c05'
import { ScoreNumber, ScoreNumberType } from 'mk2/apps/strollers/components/ScoreNumber';
import { StrollerMinEntity, UserReviewMinEntity } from 'mk2/apps/strollers/schemas';
import * as urls from 'mk2/apps/strollers/urls';
import Img from 'mk2/components/Img';
import { url } from 'mk2/helpers/urls';
import * as React from 'react';
import styles from './UserStrollerItem.mscss';

interface OwnProps {
    stroller: StrollerMinEntity;
    review?: UserReviewMinEntity;
    userId: number;
    canMaintain: boolean;
    canWriteReview: boolean;
    onRemoveMyStroller(strollerId: number, userId: number);
}

type Props = OwnProps;

export default class UserStrollerItem extends React.Component<Props> {

    private handleOnRemoveMyStroller = memoize(() => () => {
        const { stroller, userId, onRemoveMyStroller } = this.props;
        onRemoveMyStroller(stroller.id, userId);
    });

    public render() {
        const { stroller, review, canMaintain, canWriteReview } = this.props;
        const showDeleteButton = canMaintain;
        const showReviewInfo = !canMaintain;
        return (
            <div className={styles.UserStrollerItem}>
                <div className={styles.UserStrollerItem__image}>
                    <a href={url(urls.strollersDetail, { slug: stroller.slug })}>
                        <Img
                            className={styles.UserStrollerItem__image__img}
                            src={stroller.firstPhoto.url100x100}
                            width={36}
                            height={36}
                        />
                    </a>
                </div>
                <div className={styles.UserStrollerItem__meta}>
                    <a href={url(urls.strollersDetail, { slug: stroller.slug })} >
                        <div className={styles.UserStrollerItem__meta__name}>{stroller.name}</div>
                    </a>
                    { showReviewInfo && review && (
                        <a href={url(urls.strollersReview, { slug: stroller.slug, reviewId: review.id })}>
                            <span className={styles.UserStrollerItem__meta__reviewAvailable}>{USER_STROLLERS_MY_REVIEW}: </span>
                            <ScoreNumber
                                className={styles.UserStrollerItem__meta__scoreNumber}
                                score={parseFloat(review.score.toFixed(1))}
                                type={ScoreNumberType.Small}
                            />
                        </a>
                    )}
                    { showReviewInfo && !review && canWriteReview && (
                        <a href={url(urls.strollersAddReview, { slug: stroller.slug })}>
                            <div className={styles.UserStrollerItem__meta__reviewMissing}>{USER_STROLLERS_ADD_REVIEW}</div>
                        </a>
                    )}
                    { showDeleteButton && (
                        <span
                            className={styles.UserStrollerItem__meta__delete}
                            onClick={this.handleOnRemoveMyStroller()}
                        >
                            {USER_STROLLERS_DELETE}
                        </span>
                    )}
                </div>
            </div>
        );
    }
}
